import { useEffect, useState, useCallback, useMemo } from "react";
import CourseDetailDisplay from "./CourseDetailDisplay";
import Loading from "../../../layout/Loading";
import {
  Box,
  Button,
  Typography,
  Grid,
  Stack,
} from "@mui/material";
import { GetUserResult } from "../../../api/endpoints";
import { useParams, useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DateFilter from "../FilterButtons/DateFilter";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import apiClient from "../../../api/apiClient"

const EmployeeResultsContainer = () => {
  const [userResult, setUserResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const [filteredResults, setFilteredResults] = useState([]);
  const params = useMemo(() => ({
    userId: id,
  }), [id]);
  const userName = userResult && userResult.length > 0 ? [...new Set(userResult.map(course => course.userName))] : 'Bilinmeyen Kullanıcı';
  const courseName = userResult && userResult.length > 0 ? [...new Set(userResult.map(course => course.courseName))] : 'Kurs Bilgisi Yok';

  const navigate = useNavigate();
  const handleGoBack = () => {
    navigate(-1);
  };

  // DateFilter calls back with (from, to) when both ends are selected, or
  // (null, null) when the user hits "Nullstill" (reset). When the filter is
  // cleared we restore the full result set rather than filter on partial input.
  function handleDateRangeChange(from, to) {
    if (!from || !to) {
      setFilteredResults(userResult ?? []);
      return;
    }
    const filtered = (userResult ?? []).filter((item) => {
      const itemStartDate = new Date(item.startDateTime);
      const itemEndDate = new Date(item.endDateTime);
      return (
        (itemStartDate >= from && itemStartDate <= to) ||
        (itemEndDate >= from && itemEndDate <= to)
      );
    });
    setFilteredResults(filtered);
  }

  const memoizedGetUserResult = useCallback(() => {
    async function getUserResult() {
      try {
        const response = await apiClient.post(GetUserResult, params);
        const sortedData = response.data.data.sort((a, b) => {
          if (a.isActive && !b.isActive) return -1;
          if (!a.isActive && b.isActive) return 1;
          return a.courseId - b.courseId;
        });
        setUserResult(sortedData);
        setLoading(false);
        setFilteredResults(sortedData);
      } catch (err) {
        console.log(err);
      }
    }

    getUserResult();
  }, [setUserResult, setLoading, setFilteredResults, params]);

  useEffect(() => {
    memoizedGetUserResult();
  }, [memoizedGetUserResult]);

  const filteredDetails = filteredResults.length > 0 ? filteredResults.map((course, i) => {
    const courseModules = course.modules ? course.modules.map(module => {
      
      const submodules = {};
      for (const key of ['teori', 'test', 'training']) {
        if (module.submodules[key] && module.submodules[key].isScheduled) {
          submodules[key] = module.submodules[key];
        }
      }
      return {
        ...module,
        submodules: submodules,
      };
    }) : [];
  
    const updatedCourseData = {
      ...course,
      modules: courseModules,
      score: course.generalScore
    };

    return <CourseDetailDisplay key={i} courseData={updatedCourseData} />;
  }) : <Typography variant="body1">The user has no course</Typography>;

  return (
    <Grid sx={{ marginLeft: 2 }}>
      <Button
        sx={{ fontWeight: 600, marginTop: 3, marginLeft: 1, fontSize: 13,
        cursor: "pointer",
        color: "#0091ea", }}
        startIcon={<ArrowBackIcon />}
        onClick={handleGoBack}
      >
        Gå tilbake
      </Button>
      {
        !loading &&  
        <>
         <Typography variant="h6" textAlign='center' color="#424242" sx={{ mb: 2 }}>
        Ansatte informasjon
        </Typography>
  
        <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          p: 1,
          marginTop: 1,
          marginBottom: 3,
          mx: 1,
          // width: "100%",
          width: "68rem",
        }}
      > <Stack direction="row" spacing={1} sx={{backgroundColor:'#2f4874', p:1, borderRadius:3}}>
         <AccountCircleIcon fontSize="small" sx={{color:'#fff'}}/>
         <Typography  sx={{color:'#fff', fontSize:15}}>{userName}</Typography>
          </Stack>
          <DateFilter onDateChange={handleDateRangeChange} />
    </Box>
    </> 
      }
    {loading ? (
      <Grid item xs={12} md={12} sx={{display:'flex', marginTop: 5, ml:3 }}>
        <Typography sx={{ color: "#858585", marginRight: 2 }}>
        Ansatte informasjon laster inn... 
        </Typography>
        <Loading color={"#858585"} size={20} />
      </Grid>
    ) : filteredResults.length > 0 ? filteredDetails : (
      <Typography variant="body2" sx={{ mt: 4, ml: 3, color: "#909090" }}>
        The user has no course
      </Typography>
    )}
  </Grid>
);
};

export default EmployeeResultsContainer;
